import React, {Component} from 'react';
import {connect} from 'react-redux';
import ApplicationFormReferralSettings from "../components/ReferralSettings/applicationFormReferralSettings";
import {
	changeReferralSettingsState,
	changeField,
	changeKeywordAdditionForm,
	changeKeywordAdditionFormReferrer,
	changeQuestionTrigger,
	changeReferralTrigger,
	changeRefSettingsInfoState,
	closeCaseReferralKeywordAdditionModal,
	createCaseReferralKeyword,
	createCaseReferralKeywordAndAddAnother,
	openCaseReferralKeywordAdditionModal,
	requestFilteredPolicy,
	requestApplicationFormTemplate,
	requestGetPolicies,
	requestGetQuestions,
	requestPatchPolicyQuestionsGroup,
	requestPostPolicy
} from "../actions/applicationFormreferralSettings";
import {requestGetSolicitorGroups, requestGetSolicitors} from "../actions/solicitorGroup";
import _ from 'lodash';
import {getCaseTypes} from "../actions/caseTypes";
import {getSolicitorGroupCaseTypes} from "../actions/groups";
import {trimAndAddSemicolonsInsteadOfNewLines} from "../helpers/functions";
import {findQuestionById} from "../helpers/questions/functions";

class ApplicationFormReferralSettingsHOC extends Component {

	constructor(props){
		super(props);
		this.state = {
			isCopyModalOpen: false
		}
	}

	componentWillMount() {
		// this.props.getPolicies();
		this.props.getQuestions();
		this.props.getSolicitorGroups();
		this.props.getCaseTypes();
	}

	closeCopyModal = () => this.setState({...this.state, isCopyModalOpen: false});

	openCopyModal = () => this.setState({...this.state, isCopyModalOpen: true});

	handleSelectMultipleChange = (item,  questionId, triggerKey, question) =>{
		let val = '';
		_.forEach(item, (o, index) => {
			if(index  + 1 < item.length){
				val = val + o.value + ';'
			}
			else if(index  + 1 === item.length){
                val = val + o.value
			}
		});
        this.props.changeQuestionTrigger(questionId, triggerKey, val, question);
	};

	handleSelectMultipleValue = (value) => {
		return value;
	};


	handleInputChange = (evt) => {
		this.props.changeField(evt.target.name, evt.target.value);
	};

	calculateChildQuestionOptionName = (questionId) => {
		let questionName = '';
		let questions = this.props.appFormRefSettings.questions;
		loop1:
			for (let i = 0; i < questions.length; i++) {
				if (questions[i].options !== null  ) {

					for (let j = 0; j < questions[i].options.length; j++) {
						for (let k = 0; k < questions[i].options[j].childQuestionIds.length; k++) {
							if (questions[i].options[j].childQuestionIds[k] === questionId) {
								questionName = questions[i].options[j].name;
								if(questions[i].inputType === 'calendar'){
									questionName = 'calendar conditions';
								}
								break loop1;
							}

						}
					}

				}
			}

		return questionName;
	};

	viewEditForm = (evt) => {
		evt.preventDefault();
		let selectedGroup = this.props.appFormRefSettings.selectedGroup;
		let selectedCaseType = this.props.appFormRefSettings.selectedCaseType;
		let selectedSubCaseType = this.props.appFormRefSettings.selectedSubCaseType;
        this.props.requestApplicationFormTemplate()
        this.props.requestFilteredPolicy(selectedCaseType, selectedSubCaseType?selectedSubCaseType:null, selectedGroup?selectedGroup:null )
	};

	handleCheckBoxChange = (evt, question) => {
		let checked = evt.target.checked;
		let featuredQuestions = [...this.props.appFormRefSettings.featuredQuestions];
		let questionsForTriggers = [...this.props.appFormRefSettings.questionsForTriggers];
		if (checked) {
			featuredQuestions.push(question);
			questionsForTriggers.push(question);
			if (question.options.length > 0) {
				for (let i = 0; i < question.options.length; i++) {
					if (question.options[i].childQuestions !== null) {
						let childQuestions = question.options[i].childQuestions;
						for (let j = 0; j < childQuestions.length; j++) {
							questionsForTriggers.push(childQuestions[j])
						}
					}
				}
			}
		}
		else {
			for (let i = 0; i < featuredQuestions.length; i++) {
				if (featuredQuestions[i].id === question.id) {
					if (question.options.length > 0) {
						let childQuestionIds = [];
						for (let k = 0; k < question.options.length; k++) {
							if (question.options[k].childQuestions !== null) {
								let childQuestions = question.options[k].childQuestions;
								for (let j = 0; j < childQuestions.length; j++) {
									childQuestionIds.push(childQuestions[j].id)
								}
							}
						}
						for (let r = 0; r < childQuestionIds.length; r++) {
							for (let rr = 0; rr < featuredQuestions.length; rr++) {
								if (childQuestionIds[r] === featuredQuestions[rr].id) {
									questionsForTriggers.splice(r, 1);
									break;
								}
							}
						}
					}
					featuredQuestions.splice(i, 1);
					questionsForTriggers.splice(i, 1);
					break;
				}
			}
		}
		this.props.changeField('featuredQuestions', featuredQuestions);
		this.props.changeField('questionsForTriggers', questionsForTriggers);
	};

	handleCheckedState = (questionId) => {
		let featuredQuestions = this.props.appFormRefSettings.featuredQuestions;
		loop1:
			for (let i = 0; i < featuredQuestions.length; i++) {
				if (featuredQuestions[i].id === questionId) {
					return true;
					break loop1;
				}
			}
		return false;
	};

	handleSubmit = () => {
		let questionIds = [];
		let sendBody = {};
		let triggers = [];
		let selectedGroup = this.props.appFormRefSettings.selectedGroup;
		let selectedCaseType = this.props.appFormRefSettings.selectedCaseType;
		let selectedSubCaseType = this.props.appFormRefSettings.selectedSubCaseType;
		let featuredQuestions = this.props.appFormRefSettings.featuredQuestions;
		let questionsForTriggers = this.props.appFormRefSettings.questionsForTriggers;
		let questionTriggers = this.props.appFormRefSettings.questionTriggers;
		let questionReferralTriggers = this.props.appFormRefSettings.referralTriggersSettings;

		for (let i = 0; i < featuredQuestions.length; i++) {
			questionIds.push(featuredQuestions[i].id)
		}

        for (let index in questionTriggers) {
			if(questionTriggers[index].medical || questionTriggers[index].tuw || questionTriggers[index].cmu){
				const matchedQuestion = findQuestionById(index, this.props.appFormRefSettings.questions);
				triggers.push({
					questionId: index,
					medical: trimAndAddSemicolonsInsteadOfNewLines(questionTriggers[index].medical, matchedQuestion),
					tuw: trimAndAddSemicolonsInsteadOfNewLines(questionTriggers[index].tuw, matchedQuestion),
					cmu: trimAndAddSemicolonsInsteadOfNewLines(questionTriggers[index].cmu, matchedQuestion),
				})
			}
        }

		if (selectedSubCaseType === '') {
			sendBody = {
				solicitorGroupId: (this.props.appFormRefSettings.appType === 'custom') ? parseInt(selectedGroup) : null,
				caseTypeId: parseInt(selectedCaseType),
				questionIds: questionIds,
				questionsTriggers: triggers,
				referralTriggersSettings: questionReferralTriggers
			};
			//-------do not patch existing forms - always create a new one----
			this.props.submitForm(sendBody);
		}
		else if (featuredQuestions.length === 0) {
			// window.alert('select questions')
			this.props.changeField('badMsg', 'Please, select questions before submitting.')
		}
		else {
			sendBody = {
				solicitorGroupId: (this.props.appFormRefSettings.appType === 'custom') ? parseInt(selectedGroup) : null,
				caseTypeId: parseInt(selectedCaseType),
				subCaseTypeId: parseInt(selectedSubCaseType),
				questionIds: questionIds,
				questionsTriggers: triggers,
				referralTriggersSettings: questionReferralTriggers
			};
			//-------do not patch existing forms - always create a new one----
			this.props.submitForm(sendBody);
		}
	};

	calculateGroupSolicitors = () => {
		const groupId = this.props.appFormRefSettings.selectedGroup;
		const groups = this.props.appFormRefSettings.groups;
		const foundGroup  = groups.find(group => group.id.toString() === groupId.toString());
		return foundGroup ? foundGroup.solicitors : [];
	};

	//function that sorts the questions by relativity
	sortReferralQuestions = () => {
		let questions = [...this.props.appFormRefSettings.questions];
		questions = _.sortBy(questions, ["groupSortOrder", "sortOrder"]);
		return questions;
	};

	//function that groups relative questions
	groupRelativeQuestions = () => {
		let questions = [...this.props.appFormRefSettings.questions];
		questions = _.sortBy(questions, ["groupSortOrder", "sortOrder"]);
		questions = _.groupBy(questions,'groupSortOrder');
		return questions;
	};

	// function that gets the group id by group weight
	getQuestionsGroupIdByWeightId = (groupSortOrder) => {
		let questions = [...this.props.appFormRefSettings.questions];
		let temp = _.find(questions, (o) => { return groupSortOrder === o.groupSortOrder; });
		return temp?temp.groupId:null
	};

	handleSolicitorGroupChange = (name, value) => {
        this.props.getSolicitorGroupCaseTypes(value?value:-1);
        this.props.changeField(name, value);
        this.props.changeField('selectedCaseType', '');
        this.props.changeField('selectedSubCaseType', '');
    };

	_changeKeywordAdditionForm = (name, value) => {
		this.props.changeKeywordAdditionForm({
			key: name,
			value: value
		})
	};

	_changeKeywordAdditionFormReferrer = (evt) => {
		this.props.changeKeywordAdditionFormReferrer({
			key: evt.target.name,
			value: evt.target.checked
		})
	};


	_validateCaseReferralForm = () => {
		if(!this.props.appFormRefSettings.keywordAdditionForm.referredToMedicalExpert &&
            !this.props.appFormRefSettings.keywordAdditionForm.referredToTechnicalUnderwriter &&
            !this.props.appFormRefSettings.keywordAdditionForm.referredToUnderwriter){
			this.props.changeField('createCaseReferralKeywordErrorMessage', 'Please ' +
				'specify where the policy should be referred to');
			return false;
		}
		if(!this.props.appFormRefSettings.keywordAdditionForm.keyword){
            this.props.changeField('createCaseReferralKeywordErrorMessage',  '' +
				'Please specify the keyword.');
            return false;
		}
		return true;
	};

	_saveCaseReferralKeyword = () => {
		if(!this._validateCaseReferralForm()){
			return false;
		}
		this.props.createCaseReferralKeyword({
			sendBody: {keyword: this.props.appFormRefSettings.keywordAdditionForm.keyword}
		})
	};

	_saveAndCreateAnotherReferralKeyword = () => {
        if(!this._validateCaseReferralForm()){
            return false;
        }
        this.props.createCaseReferralKeywordAndAddAnother({
            sendBody: {keyword: this.props.appFormRefSettings.keywordAdditionForm.keyword}
        })
	};

	render() {
		this.groupRelativeQuestions();
		return (
			<ApplicationFormReferralSettings
				getSolicitorGroupCaseTypes={this.props.getSolicitorGroupCaseTypes}
				isCopyModalOpen={this.state.isCopyModalOpen}
				closeCopyModal={this.closeCopyModal}
				openCopyModal={this.openCopyModal}
                _saveCaseReferralKeyword={this._saveCaseReferralKeyword}
                _saveAndCreateAnotherReferralKeyword={this._saveAndCreateAnotherReferralKeyword}
                _changeKeywordAdditionFormReferrer={this._changeKeywordAdditionFormReferrer}
                _changeKeywordAdditionForm={this._changeKeywordAdditionForm}
                openCaseReferralKeywordAdditionModal={this.props.openCaseReferralKeywordAdditionModal}
                closeCaseReferralKeywordAdditionModal={this.props.closeCaseReferralKeywordAdditionModal}
				handleSolicitorGroupChange={this.handleSolicitorGroupChange}
				handleSelectMultipleValue={this.handleSelectMultipleValue}
				handleSelectMultipleChange={this.handleSelectMultipleChange}
				allCaseTypes={this.props.caseTypes.cases} // all case types
				allSubCaseTypes={this.props.caseTypes.subCases} // all case types
				requestPatchPolicyQuestionsGroup={this.props.requestPatchPolicyQuestionsGroup} // function that updated the questions group
				getQuestionsGroupIdByWeightId={this.getQuestionsGroupIdByWeightId} // function that gets the group id by group weight
				groupedQuestions={this.groupRelativeQuestions()}
				sortReferralQuestions={this.sortReferralQuestions} //function that sorts the questions by relativity
				changeRefSettingsInfoState={this.props.changeRefSettingsInfoState}
				GroupSolicitors={this.calculateGroupSolicitors}
				ChangeQuestionTrigger={this.props.changeQuestionTrigger}
				ChangeReferralTrigger={this.props.changeReferralTrigger}
				HandleCheckedState={this.handleCheckedState}
				HandleSubmit={this.handleSubmit}
				CalculateChildQuestionOptionName={this.calculateChildQuestionOptionName}
				HandleCheckBoxChange={this.handleCheckBoxChange}
				ViewEditForm={this.viewEditForm}
				HandleInputChange={this.handleInputChange}
				Store={this.props.appFormRefSettings}
				ChangeField={this.props.changeField}
				changeReferralSettingsState={this.props.changeReferralSettingsState}
			/>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		appFormRefSettings: state.applicationFormReferralSettings,
		caseTypes: state.caseTypes
	}
};


const mapDispatchToProps = (dispatch) => {
	return {
		getPolicies: () => {
			dispatch(requestGetPolicies())
		},
		getQuestions: () => {
			dispatch(requestGetQuestions())
		},
		changeField: (key, value) => {
			dispatch(changeField(key, value))
		},
		submitForm: (sendBody) => {
			dispatch(requestPostPolicy(sendBody))
		},
		changeQuestionTrigger: (questionId, triggerId, trigger, question) => {
			dispatch(changeQuestionTrigger(questionId, triggerId, trigger, question))
		},
		changeReferralTrigger: (conditionType,referTo) => {
			dispatch(changeReferralTrigger(conditionType,referTo))
		},
		getSolicitors: () => {
			dispatch(requestGetSolicitors())
		},
		changeRefSettingsInfoState: (id) => {
			dispatch(changeRefSettingsInfoState(id))
		},
		requestPatchPolicyQuestionsGroup: (weight, groupId) => {
			dispatch(requestPatchPolicyQuestionsGroup(weight, groupId))
		},
		getCaseTypes: () => {
			dispatch(getCaseTypes())
		},
		getSolicitorGroups: () => {
			dispatch(requestGetSolicitorGroups())
		},
		requestFilteredPolicy: (caseTypeId, subCaseTypeId, solicitorGroupId) => {
			dispatch(requestFilteredPolicy(caseTypeId, subCaseTypeId, solicitorGroupId))
		},
		requestApplicationFormTemplate: () => {
			dispatch(requestApplicationFormTemplate())
		},
		getSolicitorGroupCaseTypes: (groupId) => {
			dispatch(getSolicitorGroupCaseTypes(groupId))
		},
		changeReferralSettingsState: (payload) => {
			dispatch(changeReferralSettingsState(payload))
		},
		openCaseReferralKeywordAdditionModal: (payload) => {
			dispatch(openCaseReferralKeywordAdditionModal(payload))
		},
		closeCaseReferralKeywordAdditionModal: (payload) => {
			dispatch(closeCaseReferralKeywordAdditionModal(payload))
		},
		changeKeywordAdditionForm: (payload) => {
			dispatch(changeKeywordAdditionForm(payload))
		},
		changeKeywordAdditionFormReferrer: (payload) => {
			dispatch(changeKeywordAdditionFormReferrer(payload))
		},
		createCaseReferralKeywordAndAddAnother: (payload) => {
			dispatch(createCaseReferralKeywordAndAddAnother(payload))
		},
		createCaseReferralKeyword: (payload) => {
			dispatch(createCaseReferralKeyword(payload))
		}
	}
};

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationFormReferralSettingsHOC);